import { AppData } from '@app-interfaces';
import { UtilityService } from '@eforall/common';
import { FuncData } from '@interfaces';



/**
 * Convert func data into structures that can more
 * easily be used in the app (e.g. compound objects)
  */
export function processData(data: FuncData, util: UtilityService): AppData {

	//
	// Return all the data
	//
	return {
		asOfUtc: data.asOfUtc,
		user: data.user,
	};
}
